import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const InvoiceDetail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { invoice } = location.state || {}; // Get invoice data from navigation state

  
  // If no invoice is found in the state, display an error message
  if (!invoice) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-blue-100 to-white">
        <div className="text-center bg-white p-6 rounded-lg shadow-lg">
          <h1 className="text-2xl font-bold text-gray-700">Invoice Not Found</h1>
          <button
            onClick={() => navigate(-1)}
            className="mt-4 bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
          >
            Go Back
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-100 to-white p-6">
      <div className="max-w-5xl mx-auto bg-white rounded-lg shadow-lg">
        {/* Header Section */}
        <div className="bg-green-300 text-white rounded-t-lg px-6 py-4">
          <h1 className="text-2xl font-bold">Transaction Details</h1>
          <p className="text-sm">Transaction ID: {invoice.transactionId}</p>
        </div>

        {/* Main Content */}
        <div className="p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Transaction Details */}
            <div className="border p-6 rounded-lg shadow-sm bg-gray-50">
              <h2 className="text-lg font-bold text-gray-800 mb-4">Transaction Details</h2>
              <p className="mb-2">
                <strong>ID Transaction:</strong> {invoice.transactionId}
              </p>
              <p className="mb-2">
                <strong>Payment Method:</strong> {invoice.paymentMethod}
              </p>
              <p className="mb-2">
                <strong>Payment Date:</strong> {invoice.date}
              </p>
            </div>

            {/* Report Details */}
            <div className="border p-6 rounded-lg shadow-sm bg-gray-50">
              <h2 className="text-lg font-bold text-gray-800 mb-4">Report Details</h2>
              <p className="mb-2">
                <strong>Report ID:</strong> {invoice.reportId}
              </p>
              <p className="mb-2">
                <strong>Full Name:</strong> {invoice.fullName}
              </p>
            </div>
          </div>

          {/* Recipients Section */}
          <div className="mt-6 border p-6 rounded-lg shadow-sm bg-gray-50">
            <h2 className="text-lg font-bold text-gray-800 mb-4">Recipients</h2>
            <p className="mb-2">
              <strong>Name:</strong> {invoice.recipientName}
            </p>
            <p className="mb-2">
              <strong>Email:</strong> {invoice.recipientEmail}
            </p>
            <p>
              <strong>Telephone:</strong> {invoice.telephone}
            </p>
          </div>

          {/* Back Button */}
          <div className="mt-8 text-center">
            <button
              onClick={() => navigate(-1)}
              className="bg-blue-500 text-white px-6 py-2 rounded-lg shadow hover:bg-blue-600 transition"
            >
              Back
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceDetail;
